import jsonToFormData from 'json-form-data';

import api from '../config/api';

import { formatErrorResponse, formatAuthResponse } from '../utils/response';
import { makeSearchParams } from '../utils/params';
import { formatProfileResponse } from '../utils/formFormatter';

export async function loadPermissions() {
  const response = await api.get('/account/permissions', {});
  if (response.ok) {
    return { ok: true, list: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadDashboard() {
  const response = await api.get('/account/permissions', {});
  if (response.ok) {
    return { ok: true, data: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadPlan() {
  const response = await api.get('/account/plan', {});
  if (response.ok) {
    return { ok: true, plan: response.data };
  }
  return formatErrorResponse(response);
}

export async function loadAccountCatalog(page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get('/account/catalog', {}, { params });
  if (response.ok) {
    return {
      page,
      ...extra,
      ok: true,
      products: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
    };
  }
  return formatErrorResponse(response);
}

export async function sendInvite(invite) {
  const body = { invite };
  const response = await api.post('/invites', body);
  if (response.ok) {
    return {
      ok: true,
      invite: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function cancelInvite(id) {
  const response = await api.delete(`/invites/${id}`);
  if (response.ok) {
    return {
      ok: true,
      invite: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function acceptInvite({ key, ...invite }) {
  const response = await api.post(`/invites/${key}/accept`, { invite });
  if (response.ok) {
    return {
      ok: true,
      invite: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function loadAccountProfile() {
  const response = await api.get('/account');
  if (response.ok) {
    return {
      ok: true,
      profile: formatProfileResponse(response.data),
    };
  }
  return formatErrorResponse(response);
}

export async function updateUserInfo(account) {
  const params = jsonToFormData({ account });
  const response = await api.put('/account', params);
  if (response.ok) {
    return {
      ok: true,
      profile: formatProfileResponse(response.data),
    };
  }
  return formatErrorResponse(response);
}

export async function updateCompanyInfo(company) {
  const params = jsonToFormData({ company });
  const response = await api.put('/account', params);
  if (response.ok) {
    return {
      ok: true,
      profile: formatProfileResponse(response.data),
    };
  }
  return formatErrorResponse(response);
}

export async function updatePassword(account) {
  const response = await api.post('/account/change_password', { account });
  if (response.ok) {
    return {
      ok: true,
      user: formatAuthResponse(response),
    };
  }
  return formatErrorResponse(response);
}



// WEBPACK FOOTER //
// ./src/services/AccountService.js